import { DateTime } from 'luxon';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

interface CalendarContextType {
  selectedDate: DateTime;
  setSelectedDate: Dispatch<SetStateAction<DateTime | undefined>>;
  handleDateChange: (day: DateTime) => void;
}

const CalendarContext = createContext<CalendarContextType | null>(null);

const useCalendarController = () => {
  const controller = useContext(CalendarContext);

  if (!controller) {
    throw new Error(
      'useCalendarController must be used within <CalendarContext>',
    );
  }

  return controller;
};

export { CalendarContext, useCalendarController };
